var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSummaryPropertyIcon = function SvgSummaryPropertyIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D7C54",
    d: "M6.677 18.693V10.56h4.717v7.037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M1.332 18.784V8.228l7.732-6.386 7.675 6.386v10.556H1.332Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBE00",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M16.743 1v3.185M15.112 2.582h3.261"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSummaryPropertyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/Summary_Property_Icon.625709c034ffad190aacc511dfb76b38.svg";